import React from "react";

interface ScrollIndicatorProps {
    label?: string;
    className?: string;
}

/**
 * A reusable scroll indicator with a label, vertical line, and animated down arrow.
 */
export const ScrollIndicator: React.FC<ScrollIndicatorProps> = ({
    label = "Discover more",
    className = ""
}) => (
    <div className={`mt-8 flex flex-col items-center text-gray-400  ${className}`}>
        <span className="text-sm mb-2">{label}</span>
        
        
        <div className="flex flex-col items-center justify-items-center">
            {/* vertical line */}
            <div className="w-px h-8 bg-gradient-to-b from-gray-300 to-transparent" />
             {/* Down arrow icon for scroll indicator - force block and centered */}
            <div className="flex justify-center w-full ">
                <span className="inline-block animate-bounce ml-6 ">
                    <svg
                        className="w-6 h-6 block transform-none "
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        preserveAspectRatio="xMidYMid meet"
                        aria-hidden="true"
                        role="img"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </span>
            </div>
        </div>
    </div>
);

export default ScrollIndicator;
